export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-mcdonalds@2x.0aabb600fe55a956b6d0af12d9ac44cc.png";